import { Fragment, useEffect, useState } from "react";
import FooterPostup from "../../modules/public/footer/footer";
import Menu from "../../modules/public/menu/menu";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getService } from "../../function/helper";
import setLoadingState from "../../function/setLoadingState";
import Swal from "sweetalert2";
import Loading from "../../modules/public/loading/loading";
import ShipmentInformation from "./components/ShipmentInformation";
import ShipmentDestination from "./components/ShipmentDestination";
import PayGrid from "./components/PayGrid";

function PayPage() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState([true, false]);
  const navigate = useNavigate();
  const [shipment, setShipment] = useState({
    destination: { address_external: {}, country: {} },
    external_orders: [],
    source: {
      city: {},
      province: {},
    },
  });

  useEffect(() => {
    const numberParcel = searchParams.get("id");
    if (!numberParcel) navigate("/");

    getData(numberParcel);
  }, []);

  const getData = async numberParcel => {
    setLoading(cur => setLoadingState({ array: cur, index: 0, value: true }));
    const response = await getService("/external-post/v1/pay", {
      numberParcel: numberParcel,
    });
    setLoading(cur => setLoadingState({ array: cur, index: 0, value: false }));

    if (response.status === 200) {
      setShipment(() => response.data.externalPost);
    } else {
      Swal.fire({
        icon: "error",
        text: response.message,
        confirmButtonText: "متوجه شدم",
      }).then(res => {
        if (res.isConfirmed) navigate("/");
      });
    }
  };

  if (loading[0] === true) return <Loading />;

  return (
    <Fragment>
      <Menu />
      <main className="container py-4 flex-grow-1 rtl-all">
        <h4>
          <span>شماره سفارش: </span>
          <span>{shipment.numberParcel}</span>
        </h4>

        <ShipmentDestination
          destination={shipment.destination}
          source={shipment.source}
          deliveryType={shipment.delivery_type}
          transitTime={shipment.transit_time}
        />
        <ShipmentInformation parts={shipment.external_orders} />

        <PayGrid
          numberParcel={shipment.numberParcel}
          price={shipment.realPayable}
        />
      </main>
      <FooterPostup />
    </Fragment>
  );
}

export default PayPage;
